<script lang="ts">
    import { TagSet } from '@uikit/tag-set';
    import { getOptionGroups, Select, type SelectProps, type SelectTypes } from '@uikit/form/select';

    import s from './multiselect.module.css';
    import { getVisibleOptionsGroups } from './functions';

    export let selectProps: SelectProps;
    export let selectedOptions: SelectTypes.Option[] = [];
    export let limit: number = Infinity;
    export let isSelectedOutside: boolean = false;
    export let removeHandler: (option: SelectTypes.Option) => void = () => {};
    export let shouldRefreshDropdownOnSelect: boolean = true;

    /**
     * Resetting options from selectProps before passing them into Select
     * to prevent unnecessary reactivity
     */
    const OPTIONS_STUB_FORCED: SelectTypes.Option[] = [];
    let selectEl: Select;

    $: visibleOptionsGroups = getVisibleOptionsGroups(
        getOptionGroups(selectProps.optionsGroups, selectProps.options),
        selectedOptions,
    );

    function inputHandler(value: string) {
        selectProps.inputHandler?.(value);
    }

    function selectHandler(clickedValue: SelectTypes.Option) {
        selectProps.changeHandler?.(clickedValue);
        selectedOptions = [...selectedOptions, clickedValue];
        if (shouldRefreshDropdownOnSelect) {
            selectEl.clean();
            selectProps.inputHandler?.('');
        }
    }

    function removeSelectedHandler(removedLabel: string) {
        const removedOption = selectedOptions.find(({ label }) => label === removedLabel);
        if (removedOption) {
            removeHandler(removedOption);
            selectedOptions = selectedOptions.filter((option) => option !== removedOption);
        }
    }

    $: items = selectedOptions.map((item) => ({
        ...item,
        iconClickHandler: removeSelectedHandler,
        clickHandler: undefined,
    }));
</script>

<div class={s.container}>
    {#if isSelectedOutside}
        <TagSet {items} />
    {/if}

    <Select
        bind:this={selectEl}
        {...selectProps}
        optionsGroups={visibleOptionsGroups}
        options={OPTIONS_STUB_FORCED}
        changeHandler={selectHandler}
        {inputHandler}
        disabled={selectProps.disabled || selectedOptions.length >= limit}
        inputClasses={s.input}
        icon={null}
        shouldCloseDropdownOnSelect={selectProps.shouldCloseDropdownOnSelect ?? shouldRefreshDropdownOnSelect}
    >
        <TagSet items={isSelectedOutside ? null : items} slot="before-input" />
        <slot name="notFound" slot="notFound" />
    </Select>
</div>
